import { css } from "styled-components";
import colors from "../../tokens/colors";

export const socialIconVariable = css`
  --social-icon-stroke: ${colors.secondary.ashGrey};
  --social-icon-stroke-hover: ${colors.primary.cardanoBlue};
  --social-icon-set-header: ${colors.primary.cardanoBlue};
`;
